const IN_THE_GROUP = 'inTheGroup';
const NOT_IN_THE_GROUP = 'notInTheGroup';

export {
  IN_THE_GROUP,
  NOT_IN_THE_GROUP,
};
